import { IconProps } from "./Icon.model";

export function TrashCanIcon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "var(--slate-8)" : `var(--${fill}-8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.67365 0.016384C5.95619 0.0416547 6.22175 0.127878 6.44979 0.297956C6.61843 0.423738 6.73562 0.577712 6.8357 0.744463C6.92845 0.898989 7.02184 1.09165 7.12777 1.3102L7.34113 1.75035H9.5C9.77614 1.75035 10 1.97421 10 2.25035C10 2.52649 9.77614 2.75035 9.5 2.75035C6.49988 2.75035 3.5001 2.75035 0.5 2.75035C0.223858 2.75035 0 2.52649 0 2.25035C0 1.97421 0.223858 1.75035 0.5 1.75035H2.70488L2.88278 1.36008C2.98606 1.13348 3.07702 0.933911 3.16838 0.773771C3.26694 0.601034 3.38361 0.441183 3.55431 0.310228C3.78516 0.133128 4.05607 0.0433432 4.34496 0.0170438C4.56246 -0.00275683 4.78172 -3.14791e-05 5 0.000319326C5.2554 0.000729781 5.48498 -0.000490097 5.67365 0.016384ZM3.80388 1.75035H6.22983C6.11652 1.51665 6.04398 1.36853 5.9783 1.2591C5.88216 1.09894 5.76697 1.02872 5.58456 1.01241C5.45492 1.00081 5.28597 1.00035 5.01726 1.00035C4.74186 1.00035 4.56849 1.00083 4.43562 1.01293C4.24857 1.02995 4.13195 1.10284 4.03696 1.26933C3.97471 1.37844 3.90694 1.52448 3.80388 1.75035Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.79124 7.20319C8.75289 7.82979 8.72246 8.32703 8.66008 8.72422C8.5961 9.13155 8.4937 9.47076 8.28887 9.76746C8.10147 10.0389 7.8602 10.268 7.58039 10.4402C7.27456 10.6283 6.93303 10.7106 6.52656 10.75L3.4637 10.7499C3.05675 10.7105 2.71486 10.628 2.4088 10.4395C2.12882 10.267 1.88747 10.0375 1.70014 9.76566C1.49537 9.46846 1.39328 9.12874 1.32979 8.72084C1.26787 8.32309 1.23811 7.82516 1.20061 7.19767L0.875 1.75H9.125L8.79124 7.20319ZM3.125 5.5332C3.125 5.3261 3.29289 5.1582 3.5 5.1582H6.5C6.70711 5.1582 6.875 5.3261 6.875 5.5332C6.875 5.74031 6.70711 5.9082 6.5 5.9082H3.5C3.29289 5.9082 3.125 5.74031 3.125 5.5332ZM4.25 7.11719C4.04289 7.11719 3.875 7.28508 3.875 7.49219C3.875 7.69929 4.04289 7.86719 4.25 7.86719H5.75C5.95711 7.86719 6.125 7.69929 6.125 7.49219C6.125 7.28508 5.95711 7.11719 5.75 7.11719H4.25Z"
        fill={fillColor}
      />
    </svg>
  );
}
